module.exports = __webpack_public_path__ + "img/icon-mc_dark.c0d48db5.png";